'use es6';

export const disableHubSpotCookieBanner = () => {
  window.disableHubSpotCookieBanner = true;
  window._hsp = window._hsp || [];
  window._hsp.push(['revokeCookieConsent']);
};